const STORAGE_KEY = "profile-ui";

export const loadProfilePersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveProfilePersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist profile state", error);
  }
};

export const clearProfilePersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getPersistedProfileUiState = () => {
  const data = loadProfilePersistence();
  if (!data) {
    return {
      hasCache: false,
      formValues: {},
      countries: [],
      states: []
    };
  }

  const formValues =
    data.formValues && typeof data.formValues === "object" ? data.formValues : {};
  const countries = Array.isArray(data.countries) ? data.countries : [];
  const states = Array.isArray(data.states) ? data.states : [];

  return {
    hasCache: Boolean(formValues.email || formValues.name || formValues.phone),
    formValues,
    countries,
    states
  };
};
